export function errorMessage(error) {
  try {
    const e =
      error.response.statusText || error.response.data.error || error.message
    if (!e) {
      throw new Error('Generic Error')
    }
    return e
  } catch (error) {
    console.log(error)
    return 'Generic Error'
  }
}



// WEBPACK FOOTER //
// ./src/helpers.js